@if (this.surveyEditorService.surveyEditor$().activeHiddenQuestion; as activeQuestion) {
  <div [formGroup]="activeQuestion" class="hidden-choice-settings__container">
    <empathy-hidden-choice-settings [activeQuestion]="activeQuestion"></empathy-hidden-choice-settings>
  </div>
}
